import React, { useEffect, useState } from 'react';
import { HeadTitle, Icon, SpacerSection, Trg16, Spacer, SimpleItem, Bottomsheet } from 'oui';
import { SideBox, FlexBox } from '../../etc/LBox/LBox';
import useNav from '../../../application/hooks/useNav';
import { useRecoilValue, useRecoilState } from 'recoil';
import * as Atom from "../../../application/recoil";
import { beaconSelector } from '../../../application/recoil/selector';
import useBeacon, {
  ClkBtnSubEventNm,
} from '../../../application/hooks/useBeacon';
import { PAGE_NM } from '../../../application/types/types';
import { useBaseParam } from '../../../application/hooks/useBaseParam';
import { fetchHouseReqList } from '../../../infra/api/mtg/fetchHouseReqList';
import Survey from '../../etc/Survey/Survey';

export const MtgResultStatus = () => {
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.MTG_STATUS,
  });
  const sendBeaconClkBtn = (subEventNm: string, properties: any) => {
    beacon.sendClkBtn({
      events: { subEventName: subEventNm },
      properties:
        typeof properties === 'string' ? { btnNm: properties } : properties,
    });
  };
  const [ requestList, setRequestList ] = useState<any[]>([]);
  const [personal] = useRecoilState(Atom.personalInfo);
  const fetchHouseReq = useBaseParam(fetchHouseReqList, {custSeq: personal.custSeq});

  const loadHouseRequestList = async () => {
    const res = await fetchHouseReq();
    const requestList = res.data.result;
    if (requestList && requestList.length > 0) {
      (requestList  as any[]).forEach((custRequest) => {
        if (custRequest?.housePreRequestInfoData) {
          Atom.resetAmtUnit(custRequest?.housePreRequestInfoData);
        }
      });
      setRequestList(requestList);
    }
  }

  const [showSurvey, setShowSurvey] = useState<boolean>(false);

  useEffect(() => {
    beacon.sendViewPage();
    loadHouseRequestList();
  }, []);
  
  const { navigate } = useNav();
  const onClickListItem = (index: number) => {
    navigate(
      `/mtg/detail/${requestList[index]?.houseCustProductInfo?.houseRequestProductInfo?.requestSeq ?? 0}/${requestList[index]?.houseCustProductInfo?.housePreProductInfo?.preRequestDtlNo}`,
    );
    sendBeaconClkBtn(ClkBtnSubEventNm.ViewLoanAppinfo, requestList[index]?.houseCustProductInfo?.houseProductInfo?.productNm);
  };
  const onClickSurvey = () => {
    sendBeaconClkBtn(ClkBtnSubEventNm.CtaSurvey, '사용자 조사');
    // open survey sheet
    setShowSurvey(true);
  };

  return (
    <>
      <HeadTitle textTitle={'내가 신청한 주택담보대출'} />

      <SpacerSection
        size={'xs'}
        children={
          <SideBox>
            {requestList.map((item: any, index: number) => {
              return (
                <SimpleItem
                  key={'req_list_' + item.houseCustProductInfo?.houseRequestProductInfo?.requestSeq + index}
                  state={'enabled'}
                  avatar={{
                    source: item.houseCustProductInfo?.houseProductInfo.logoImg,
                    alt: item.houseCustProductInfo?.houseProductInfo.compNm,
                    size: 'md',
                  }}
                  headerText={item.houseCustProductInfo?.houseProductInfo.compNm}
                  subheaderText={item.houseCustProductInfo?.houseProductInfo.productNm}
                  adormentText={item.housePreRequestInfoData?.areaName ?? ""} // TODO API 수정후 담보물 이름 출력
                  onClickSimpleItem={() => onClickListItem(index)}
                />
              );
            })}
          </SideBox>
        }
      />

      <SpacerSection
        size={'md'}
        children={
          <FlexBox
            onClick={onClickSurvey}
            padding={'20px'}
            justify={'space-between'}
          >
            <Trg16 text={'대출 상담은 만족하셨나요?'} />
            <Icon name={'ChevronRightSharp'} color={'default'} size={'sm'} />
          </FlexBox>
        }
      />

      <Bottomsheet
        backdrop={true}
        isOpen={showSurvey}
        isMaxHeight={false}
        children={
          <>
            <Survey surveyType='mgt_req' isBottomSheet={true} onClickBottomSheetClose={() => setShowSurvey(false)}></Survey>
          </>
        }
      />

    </>
  );
};
